import React, { useEffect } from "react";
import icon from "../../assets/australia.png";
import mail from "../../assets/icons/mail.png";
import bell from "../../assets/icons/bell.png";
import { goToLogout, isTokenExpired } from "../../api/client";
import { tokenStore } from "../../api/tokenStore";
import GlobalSearch from "./GlobalSearch";
import QuickActionSelect from "../quick-action-select/QuickActionSelect";

const MenuIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);


/**
 * Does this page already put a Quick Actions control in the navbar?
 *
 * 42 of the 45 pages passed their own, in a handful of different shapes
 * bare, wrapped in a fragment, behind a condition, and the remaining 12
 * screens simply had no Quick Actions at all. The navbar now supplies one so
 * every screen matches, and this walk stops the pages that already pass one
 * from ending up with two.
 */
const containsQuickAction = (node) => {
  let found = false;
  React.Children.forEach(node, (child) => {
    if (found || !React.isValidElement(child)) return;
    if (child.type === QuickActionSelect) {
      found = true;
      return;
    }
    if (child.props?.children) found = containsQuickAction(child.props.children);
  });
  return found;
};

const Navbar = ({ children, NavName }) => {
  document.title = `${NavName} | ARM Financial`;

  useEffect(() => {
    const token = tokenStore.getAccess();
    if (token && isTokenExpired(token)) {
      goToLogout();
    }
  }, []);

  return (
    <nav className="app-navbar">
      <div className="app-navbar-left">
        <button
          type="button"
          className="navbar-icon-button sidebar-button-small-screen d-md-none"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasExample"
          aria-controls="offcanvasExample"
          aria-label="Open navigation"
        >
          <MenuIcon />
        </button>
        <h1 className="navbar-title">{NavName}</h1>
        {children && <div className="navbar-children">{children}</div>}
        {!containsQuickAction(children) && (
          <div className="navbar-children">
            <QuickActionSelect />
          </div>
        )}
      </div>

      {/* Search sits in the middle of the bar on every screen. GlobalSearch
          was fully built, Ctrl+K, recent searches, the modal, but imported
          nowhere, so the search bar had simply disappeared from the app. */}
      <div className="app-navbar-center">
        <GlobalSearch />
      </div>

      <div className="app-navbar-right">
        <div className="navbar-currency-pill">
          <span className="navbar-pill-segment">
            <img src={icon} alt="" />
            AUD
          </span>
          <span className="navbar-pill-divider" />
          <span className="navbar-pill-segment">
            <img src={icon} alt="" />
            Australia
          </span>
        </div>

        <button type="button" className="navbar-action-icon" aria-label="Mail">
          <img src={mail} alt="" />
        </button>
        <button type="button" className="navbar-action-icon" aria-label="Notifications">
          <img src={bell} alt="" />
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
